<template>
  <div class="app-container">
    <!-- <div class="filter-container flex flex-ac mb-4">
      <el-button
        size="small"
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="add"
        >新增VIP升级消息模板</el-button
      >
    </div> -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="VIP等级编号" min-width="110">
        <template slot-scope="scope">
          {{ scope.row.level_no }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="等级中文名称" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.name || '-' }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="等级英文名称" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.name_en || '-' }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="升级消息模板" min-width="180">
        <template slot-scope="scope">
          <el-tag v-if="hasTemplate(scope.row)" type="success"> 已配置 </el-tag>
          <el-tag v-else type="info">未配置</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        min-width="140"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="warning" @click="edit(scope.row)"> 修改 </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'VipUpgradeTemplate',
  data() {
    return {
      list: [],
      listLoading: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/vipLevelConfig/upgradeMessageList',
        method: 'get',
      })
        .then((res) => {
          const data = Array.isArray(res.data) ? res.data : []
          this.list = data.sort(
            (a, b) => Number(a.level_no) - Number(b.level_no),
          )
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    hasTemplate(row) {
      return (
        row &&
        row.template !== null &&
        row.template !== '' &&
        row.template !== undefined
      )
    },
    languageCount(template) {
      if (!template) return 0
      if (typeof template === 'object') return Object.keys(template).length
      try {
        const parsed = JSON.parse(template)
        return parsed && typeof parsed === 'object'
          ? Object.keys(parsed).length
          : 0
      } catch (e) {
        return 1
      }
    },
    edit(row) {
      this.$router.push(
        `/operation/vipupgradetemplateedit?vip_level_no=${row.level_no}`,
      )
    },
    add() {
      this.$router.push('/operation/vipupgradetemplateedit')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* ...existing code... */
</style>
